import { ReactElement } from 'react'
import { observer } from 'mobx-react-lite'
import { useInboxPage } from 'app/components/inbox-page/useInboxPage'
import { InboxPageComponent } from 'app/components/inbox-page/InboxPageComponent'
import { SchedulingDock } from 'app/components/inbox/scheduling-dock/SchedulingDock'
import { SchedulingDockProvider } from 'app/components/inbox/scheduling-dock/SchedulingDockContext'

export const handle = {
  title: `Inbox`,
}

export default observer(function Inbox(): ReactElement {
  const props = useInboxPage()
  return (
    <SchedulingDockProvider locationId={props.data.locationId || undefined}>
      <InboxPageComponent {...props} />
      <SchedulingDock />
    </SchedulingDockProvider>
  )
})
